import { Link, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { categories } from "@/mocks/movies";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === "/";

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const navClasses = isHome && !scrolled
    ? "fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-transparent"
    : "fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-background-50/95 backdrop-blur-md border-b border-background-200/60";

  const textClasses = isHome && !scrolled
    ? "text-white"
    : "text-foreground-900";

  return (
    <header className={navClasses}>
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 group">
            <div className={`w-9 h-9 rounded-lg flex items-center justify-center ${isHome && !scrolled ? "bg-white/20" : "bg-primary-500"}`}>
              <i className={`ri-movie-2-line text-xl ${isHome && !scrolled ? "text-white" : "text-background-50"}`}></i>
            </div>
            <span className={`text-xl font-heading font-bold whitespace-nowrap ${textClasses}`}>
              <strong>红桃影视</strong>
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1" aria-label="主导航">
            <Link
              to="/"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${isHome && !scrolled ? "text-white/90 hover:text-white hover:bg-white/10" : "text-foreground-700 hover:text-primary-500 hover:bg-primary-50"}`}
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${isHome && !scrolled ? "text-white/90 hover:text-white hover:bg-white/10" : "text-foreground-700 hover:text-primary-500 hover:bg-primary-50"}`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${isHome && !scrolled ? "text-white/90 hover:text-white hover:bg-white/10" : "text-foreground-700 hover:text-primary-500 hover:bg-primary-50"}`}
            >
              关于我们
            </Link>
          </nav>

          <div className="hidden md:flex items-center gap-2">
            <div className={`relative ${isHome && !scrolled ? "text-white/80" : "text-foreground-500"}`}>
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-sm"></i>
              <input
                type="text"
                placeholder="搜索影视..."
                className={`pl-9 pr-4 py-2 rounded-full text-sm border outline-none transition-all w-48 focus:w-64 ${isHome && !scrolled ? "bg-white/15 border-white/20 text-white placeholder:text-white/50 focus:bg-white/25" : "bg-background-100 border-background-200 text-foreground-900 placeholder:text-foreground-400 focus:border-primary-300"}`}
              />
            </div>
          </div>

          <button
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg ${isHome && !scrolled ? "text-white hover:bg-white/10" : "text-foreground-700 hover:bg-background-100"}`}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/60">
          <div className="px-4 py-3 space-y-1">
            <Link to="/" className="block px-4 py-2.5 rounded-lg text-sm font-medium text-foreground-700 hover:text-primary-500 hover:bg-primary-50">首页</Link>
            {categories.map((cat) => (
              <Link key={cat.slug} to={`/category/${cat.slug}`} className="block px-4 py-2.5 rounded-lg text-sm font-medium text-foreground-700 hover:text-primary-500 hover:bg-primary-50">{cat.name}</Link>
            ))}
            <Link to="/about" className="block px-4 py-2.5 rounded-lg text-sm font-medium text-foreground-700 hover:text-primary-500 hover:bg-primary-50">关于我们</Link>
            <div className="relative pt-2">
              <i className="ri-search-line absolute left-3 top-[22px] -translate-y-1/2 text-sm text-foreground-400"></i>
              <input type="text" placeholder="搜索影视..." className="w-full pl-9 pr-4 py-2 rounded-full text-sm border border-background-200 bg-background-100 text-foreground-900 placeholder:text-foreground-400 outline-none focus:border-primary-300" />
            </div>
          </div>
        </div>
      )}
    </header>
  );
}